import React from 'react';
import Card from '../common/Card.jsx';
import Barcode from '../order-details/Barcode.jsx';
import { fonts } from '../common/mixins.js';
import styled from 'styled-components';

const Small = styled.div`
    ${fonts.normalTextSmall()}; 
    display:inline;
    word-break:break-word;
    hyphens: manual; 
    `;
const Light = styled.div`
    ${fonts.lightGrayTextSmall()};
    flex-shrink: 0;
     display:inline;
     margin-right:6px;
     margin-bottom: 2px;
    `;

const DetailsContainer = styled.div`
  display:flex;
  flex-direction:column;
  padding-bottom:4px;
    `;
const FlexContainer = styled.div`
  display:flex;
    `;

const DetailsTop = ({ deliveryInformation }) => {
    return (
        <DetailsContainer>
            <Light>{orderdetails_resources.DeliveryInformation}</Light>
            <Small id="deliveryInformation">{deliveryInformation }</Small>
        </DetailsContainer>);
};

const DetailsBottom = ({ price }) => {

    return (
        <FlexContainer>
            <Light>{orderdetails_resources.Price}</Light>
            <Small style={{ marginBottom: "8px" }} id="price">{price}</Small>
        </FlexContainer>);
};

export default function Product({ data, count, hasLabel, orderStatus }) {
    //wallet liks for products will be completed in phase 2
    const googleWalletLink = `../../_api/ticket-management/GetGooglePayPass/${data.contentId}/${data.id}`;
    const appleWalletLink = `../../_api/ticket-management/GetAppleWalletPass/${data.contentId}/${data.id}`;
    const walletsLinks = {
        apple: appleWalletLink,
        google: googleWalletLink
    };
    const cardProps = {
        detailsTop: data.deliveryInformation ?<DetailsTop deliveryInformation={data.deliveryInformation}/>:null,
        detailsBottom: <DetailsBottom price={data.price} />,
        barcode: <Barcode code={data.barcode} />,
        status: data.status,
        title: data.title,
        imageUrl: data.imageUrl
    };

    return (
        <Card id="productCard" cardProps={cardProps} count={count} type="card" hasLabel={hasLabel} walletsLinks={null} orderStatus={orderStatus}/>
    );
}